module.exports = __webpack_public_path__ + "thumb-down-100.png";


//////////////////
// WEBPACK FOOTER
// ../shared-components/src/assets/images/thumb-down-100.png
// module id = 813
// module chunks = 0